function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * @file DOM 相关方法
 * @author dafo<huanghouin@baijiahulian.com>
 * @module util/dom
 */

/**
 * 为 HTML 元素绑定事件
 *
 * @function
 * @param {Element} el HTML 元素
 * @param {string} name 事件名
 * @param {Function} handler 事件处理函数
 */
export var on = function on(el, name, handler) {
  var useCapture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  el && el.addEventListener(name, handler, useCapture);
};

/**
 * 为 HTML 元素解除事件绑定
 *
 * @function
 * @param {Element} el HTML 元素
 * @param {string} name 事件名
 * @param {Function} handler 已经绑定的事件处理函数
 */
export var off = function off(el, name, handler) {
  var useCapture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  el && el.removeEventListener(name, handler, useCapture);
};

/**
 *  测试 HTML 元素的 class 中是否包含指定的 class
 *
 * @function
 * @param {Element} el HTML 元素
 * @param {string} className 测试是否包含的 class
 * @return {boolean} 如果包含指定的 class，返回 true，否则 false
 */
export var hasClass = typeof document !== 'undefined' && 'classList' in document.documentElement ? function (el, className) {
  return el.classList.contains(className);
} : function (el, className) {
  return ~" ".concat(el.className, " ").indexOf(" ".concat(className, " "));
};

/* eslint-disable require-unicode-regexp */
/**
 * 区配选择器的正则
 *
 * @const {RegExp}
 */
var SELECTOR_PATTERN = /^([a-z][a-z\d-]*)?(?:\.([a-z\d-_.]+))?(?:\[([^=\]]+)(?:=([^\]]+))?\])?$/i;
/* eslint-enable require-unicode-regexp */

/**
 * 向上查找匹配指定选择器的元素
 *
 * @param {Element} el 查找的起始 HTML 元素
 * @param {string} selector 要匹配的选择器
 * @return {?Element} 匹配到元素时返回该元素，否则返回 null
 */
export function closest(el, selector) {
  var _selector$match = selector.match(SELECTOR_PATTERN),
    _selector$match2 = _slicedToArray(_selector$match, 5),
    _selector$match2$ = _selector$match2[1],
    tag = _selector$match2$ === void 0 ? '' : _selector$match2$,
    _selector$match2$2 = _selector$match2[2],
    className = _selector$match2$2 === void 0 ? '' : _selector$match2$2,
    _selector$match2$3 = _selector$match2[3],
    attrName = _selector$match2$3 === void 0 ? '' : _selector$match2$3,
    _selector$match2$4 = _selector$match2[4],
    attrValue = _selector$match2$4 === void 0 ? '' : _selector$match2$4;
  tag = tag.toUpperCase();
  attrValue = attrValue.replace(/^(["'])((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)\1$/, '$2');
  var is = function is(el) {
    return el && (!tag || el.tagName === tag) && (!className || el.className && hasClass(el, className)) && (!attrName || attrName && !attrValue && el.hasAttribute(attrName) || attrName && attrValue && el.getAttribute(attrName, 2) === attrValue);
  };
  var parent = el;
  while (parent && parent.tagName !== 'HTML') {
    if (is(parent)) {
      return parent;
    }
    parent = parent.parentNode;
  }
}

/**
 * 获取指定 URL 的 pathname
 *
 * @function
 * @param {string} [url=location.href]  要处理的 URL
 * @return {string} 移除域名后的 pathname，SPA 页面取第一个 # 后面的路径
 */
export var getPageURL = function getPageURL() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.href;
  return url.replace(/^(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*\/\/(?:(?!\/)[\s\S])+(\/#)?(?=\/)/, '');
};

/**
 * 视窗范围
 *
 * @typedef {Object} ViewPort
 * @property {number} left 左边界
 * @property {number} right 左边界
 * @property {number} top 上边界
 * @property {number} bottom 下边界
 */

/**
 * 获取当前视窗范围
 *
 * @function
 * @return {ViewPort} 返回当前视窗的坐标值
*/
export var getViewPort = function getViewPort() {
  var _document$documentEle = document.documentElement,
    scrollLeft = _document$documentEle.scrollLeft,
    scrollTop = _document$documentEle.scrollTop,
    clientWidth = _document$documentEle.clientWidth,
    clientHeight = _document$documentEle.clientHeight;
  return {
    left: scrollLeft,
    right: scrollLeft + clientWidth,
    top: scrollTop,
    bottom: scrollTop + clientHeight
  };
};

/**
 * 判断指定 HTML 元素是否在视窗内
 *
 * @function
 * @param {Element} el 待判断的 HTML 元素
 * @return {boolean} el 在视窗内时返回 true，否则返回 false
 */
export var isInViewPort = function isInViewPort(el) {
  var html = document.documentElement;
  var _document = document,
    body = _document.body;
  var viewPort = {
    top: 0,
    left: 0,
    right: html.clientWidth || body.clientWidth,
    bottom: html.clientHeight || body.clientHeight
  };
  var targetRect = el.getBoundingClientRect();
  var intersectWidth = (viewPort.right > targetRect.right ? targetRect.right : viewPort.right) - (viewPort.left > targetRect.left ? viewPort.left : targetRect.left);
  var intersectHeight = (viewPort.bottom > targetRect.bottom ? targetRect.bottom : viewPort.bottom) - (viewPort.top > targetRect.top ? viewPort.top : targetRect.top);
  return intersectWidth > 0 && intersectHeight > 0;
};